import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { ChatbotService } from '../../chatbot-services/chatbot.service';
import { ConfigurationService } from '../../configuration/configuration.service';
import { DevAuthService } from '../../dev-service/dev-auth/dev-auth.service';
import { GlobalConfigService } from '../../global-service/global-service.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class ChatbotInterceptorInterceptor implements HttpInterceptor {

  constructor(
    private readonly chatbotService: ChatbotService,
    private readonly configService: ConfigurationService,
    private readonly devAuthService: DevAuthService,
    private readonly globalConfigService: GlobalConfigService
  ) {
    this.ConfigDate = configService.config;
  }

  ConfigDate: any;
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
  // WHITELIST APPROACH: Only add custom headers to chatbot-common API endpoints
  const isChatbotApi = request.url.includes('chatbot-common');

  // If NOT a chatbot-common API, pass through without adding headers
  if (!isChatbotApi) {
    return next.handle(request);
  }

  // Generate unique request ID for traceability
  const requestId = this.globalConfigService.generateRequestId();

  // Prepare headers object for chatbot-common APIs
  const headers: { [key: string]: string } = {
    'X-Chatbot-APIKey': this.ConfigDate.apiKey,
    'X-Chatbot-UserKey': (environment.UserKey == undefined || environment.UserKey == null) ? "" : environment.UserKey,
    'API-Request-ID': requestId
  };

  // Add dev auth token only in development environment
  if (this.ConfigDate?.ENVIRONMENT === 'development' || this.ConfigDate?.ENVIRONMENT === 'dev') {
    const accessToken = this.devAuthService.getAccessToken();
    if (accessToken) {
      headers['Authorization'] = `Bearer ${accessToken}`;
    }
  }

  // Clone request with all headers
  const modifiedRequest = request.clone({
    setHeaders: headers
  });

  // Continue with the modified request
  return next.handle(modifiedRequest);
  }
}
